"use client"
import ImageCustom from '@/components/Image'
import { BlockType } from '@/libs/types'
import clsx from 'clsx'
import React from 'react'
import { Carousel } from "react-bootstrap"
import ContentProblemMarkdown from '../../ContentProblemMarkdown'

const CarouselCustomized: React.FC<{ locale: string, block: BlockType }> = ({ locale, block }) => {
    const [active, setActive] = React.useState(0)

    const handleSelect = (selectedActive: any) => {
        setActive(selectedActive);
      };
    return (
        <>
        <Carousel activeIndex={active} onSelect={handleSelect} interval={null}>
            {block.blocks[0].blocks && block.blocks[0].blocks.length !== 0 && (
                block.blocks[0].blocks.map((_, index: number) => {
                    const blockTop: BlockType = block.blocks[0].blocks[index]
                    const blockBottom: BlockType = block.blocks[1].blocks[index]
                    return (
                        <Carousel.Item key={index} className="w-100">
                            <div className={clsx(blockTop.classes, "carousel-content-one w-100")}>
                                <div className="carousel-content-one-gallery-container d-flex mb-md-3">
                                    <figure className="carousel-content-one-gallery-img m-auto">
                                        <ImageCustom src={blockTop.thumb} loading="lazy" fill alt={blockTop.title}
                                            className="object-fit-contain" />
                                    </figure>
                                </div>
                                {!!blockTop.content && <ContentProblemMarkdown
                                    locale={locale}
                                    content={blockTop.content} />}
                            </div>
                            
                            <div className={clsx(blockBottom.classes, "carousel-content-one bottom w-100 mt-5 text-primary")}>
                                <div className="carousel-content-one-gallery-container mb-3">
                                    <figure className="carousel-content-one-gallery-img m-auto">
                                        <ImageCustom src={blockBottom.thumb} loading="lazy" fill alt={blockBottom.title}
                                            className="object-fit-contain" />
                                    </figure>
                                </div>
                                {!!blockBottom.content && <ContentProblemMarkdown
                                    locale={locale}
                                    content={blockBottom.content} />}
                            </div>
                        </Carousel.Item>
                    )
                    
                })
            )}
        </Carousel>
       
      </>
    )
}

export default CarouselCustomized